import { compose } from 'redux';
import { WithFetchDatasByIdFromCMS, WithFetchDatasByIdFromCMSInputProps } from 'modules/shared-cms/hocs';
import { TrendBlocContainerOwnProps } from 'modules/shared-cms-catalogue/components';
import { WithFetchProducts } from 'modules/shared-cms-catalogue/hocs';
import { CmsProductListProps } from 'modules/shared-cms-catalogue/types';

import { QUERY } from './carrousel-catalogue-query';
import { CarrouselCatalogueLoader } from './carrousel-catalogue-component-loader';

const enhancer = compose<React.ComponentType<WithFetchDatasByIdFromCMSInputProps>>(
    WithFetchDatasByIdFromCMS<TrendBlocContainerOwnProps & CmsProductListProps>(
        QUERY,
        CarrouselCatalogueLoader,
        'findCarrouselCatalogueContent',
    ),
    WithFetchProducts(CarrouselCatalogueLoader),
);

export default enhancer;
